module.exports = __webpack_public_path__ + "static/img/contactImg.a1ed916.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageFour/contactImg.png
// module id = kcIA
// module chunks = 0